// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/webhookpb/v1/webhook.proto (package unacast.boundaries.webhookpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum unacast.boundaries.webhookpb.v1.WebhookType
 */
export enum WebhookType {
  /**
   * @generated from enum value: WEBHOOK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEBHOOK_TYPE_IMPORT_COMPLETE = 1;
   */
  IMPORT_COMPLETE = 1,

  /**
   * @generated from enum value: WEBHOOK_TYPE_VALIDATION_COMPLETE = 2;
   */
  VALIDATION_COMPLETE = 2,

  /**
   * @generated from enum value: WEBHOOK_TYPE_EXPORT_COMPLETE = 3;
   */
  EXPORT_COMPLETE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(WebhookType)
proto3.util.setEnumType(WebhookType, "unacast.boundaries.webhookpb.v1.WebhookType", [
  { no: 0, name: "WEBHOOK_TYPE_UNSPECIFIED" },
  { no: 1, name: "WEBHOOK_TYPE_IMPORT_COMPLETE" },
  { no: 2, name: "WEBHOOK_TYPE_VALIDATION_COMPLETE" },
  { no: 3, name: "WEBHOOK_TYPE_EXPORT_COMPLETE" },
]);

/**
 * @generated from enum unacast.boundaries.webhookpb.v1.WebhookStatus
 */
export enum WebhookStatus {
  /**
   * @generated from enum value: WEBHOOK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEBHOOK_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: WEBHOOK_STATUS_INACTIVE = 2;
   */
  INACTIVE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(WebhookStatus)
proto3.util.setEnumType(WebhookStatus, "unacast.boundaries.webhookpb.v1.WebhookStatus", [
  { no: 0, name: "WEBHOOK_STATUS_UNSPECIFIED" },
  { no: 1, name: "WEBHOOK_STATUS_ACTIVE" },
  { no: 2, name: "WEBHOOK_STATUS_INACTIVE" },
]);

/**
 * @generated from enum unacast.boundaries.webhookpb.v1.WebhookHealth
 */
export enum WebhookHealth {
  /**
   * @generated from enum value: WEBHOOK_HEALTH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEBHOOK_HEALTH_HEALTHY = 1;
   */
  HEALTHY = 1,

  /**
   * @generated from enum value: WEBHOOK_HEALTH_UNHEALTHY = 2;
   */
  UNHEALTHY = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(WebhookHealth)
proto3.util.setEnumType(WebhookHealth, "unacast.boundaries.webhookpb.v1.WebhookHealth", [
  { no: 0, name: "WEBHOOK_HEALTH_UNSPECIFIED" },
  { no: 1, name: "WEBHOOK_HEALTH_HEALTHY" },
  { no: 2, name: "WEBHOOK_HEALTH_UNHEALTHY" },
]);

/**
 * @generated from message unacast.boundaries.webhookpb.v1.Webhook
 */
export class Webhook extends Message<Webhook> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string owner_id = 2;
   */
  ownerId = "";

  /**
   * @generated from field: unacast.boundaries.webhookpb.v1.WebhookType type = 3;
   */
  type = WebhookType.UNSPECIFIED;

  /**
   * @generated from field: string url = 4;
   */
  url = "";

  /**
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * Prevent API trying to create secret
   *
   * @generated from field: optional string secret = 6;
   */
  secret?: string;

  /**
   * @generated from field: unacast.boundaries.webhookpb.v1.WebhookStatus status = 7;
   */
  status = WebhookStatus.UNSPECIFIED;

  /**
   * @generated from field: unacast.boundaries.webhookpb.v1.WebhookHealth health = 8;
   */
  health = WebhookHealth.UNSPECIFIED;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<Webhook>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.webhookpb.v1.Webhook";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(WebhookType) },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(WebhookStatus) },
    { no: 8, name: "health", kind: "enum", T: proto3.getEnumType(WebhookHealth) },
    { no: 9, name: "created_at", kind: "message", T: Timestamp, opt: true },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Webhook {
    return new Webhook().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Webhook {
    return new Webhook().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Webhook {
    return new Webhook().fromJsonString(jsonString, options);
  }

  static equals(a: Webhook | PlainMessage<Webhook> | undefined, b: Webhook | PlainMessage<Webhook> | undefined): boolean {
    return proto3.util.equals(Webhook, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.webhookpb.v1.WebhookExecution
 */
export class WebhookExecution extends Message<WebhookExecution> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string event_id = 2;
   */
  eventId = "";

  /**
   * @generated from field: string webhook_id = 3;
   */
  webhookId = "";

  /**
   * @generated from field: google.protobuf.Timestamp executed_at = 4;
   */
  executedAt?: Timestamp;

  /**
   * @generated from field: int32 http_status = 5;
   */
  httpStatus = 0;

  /**
   * @generated from field: bool success = 6;
   */
  success = false;

  /**
   * Prevent API trying to create request payload
   *
   * @generated from field: optional string request_payload = 7;
   */
  requestPayload?: string;

  /**
   * Prevent API trying to create response body
   *
   * @generated from field: optional string response_body = 8;
   */
  responseBody?: string;

  /**
   * Prevent API trying to create error
   *
   * @generated from field: optional string error = 9;
   */
  error?: string;

  /**
   * @generated from field: optional int32 duration_ms = 10;
   */
  durationMs?: number;

  constructor(data?: PartialMessage<WebhookExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.webhookpb.v1.WebhookExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "executed_at", kind: "message", T: Timestamp },
    { no: 5, name: "http_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "request_payload", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "response_body", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "duration_ms", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WebhookExecution {
    return new WebhookExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WebhookExecution {
    return new WebhookExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WebhookExecution {
    return new WebhookExecution().fromJsonString(jsonString, options);
  }

  static equals(a: WebhookExecution | PlainMessage<WebhookExecution> | undefined, b: WebhookExecution | PlainMessage<WebhookExecution> | undefined): boolean {
    return proto3.util.equals(WebhookExecution, a, b);
  }
}

